import { Component, EventEmitter, OnInit, Output, ViewEncapsulation, inject } from '@angular/core';
import {
  Bank, BankConnection, BankConnectionCollection,
  BankConnectionService, BankService,
} from 'taxtank-core';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@shared/component/base/base.component';
import { combineLatest } from 'rxjs';

/**
 * Component with list of available banks
 */
@Component({
  selector: 'app-banks',
  templateUrl: './banks.component.html',
  styleUrls: ['./banks.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class BanksComponent extends BaseComponent implements OnInit, OnInit {
  @Output() selected: EventEmitter<BankConnection> = new EventEmitter();

  private bankConnectionService = inject(BankConnectionService);
  private bankService = inject(BankService);

  /**
  * Show preloader after choosing a bank
  */
  hasSelected: boolean;

  /**
   * List of user's bank connections
   */
  connections: BankConnectionCollection;

  /**
   * List of all bank allowed to connect
   */
  banks: Bank[];

  ngOnInit(): void {
    combineLatest([this.bankConnectionService.get(), this.bankService.get()])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([connections, banks]): void => {
        this.banks = banks.diff(connections.mapBy('bank'))
          .filterBy('isActive', true)
          .sortBy('isPopular')
          .toArray();
      });
  }

  select(connection: BankConnection): void {
    this.selected.emit(connection);
  }
}
